import React, {memo, useCallback, useEffect, useMemo, useState, useRef} from 'react';
import { CameraModel } from '../../types/control';
import './index.scss';
import {Container} from '../../components/Container';
import {useDispatch, useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {useOrientation} from '../../hooks/orientation';
import {CameraRenderer} from '../../components/CameraRenderer';
import { backButtonToggle, groupSettingAction } from "../../store/ui/actions";
import Webcam from 'react-webcam';
import { useRPC } from '../../hooks/rpc';
import { setEntityListAction } from '../../store/control/actions';
//import { useHistory } from 'react-router-dom';
//import { useMessage } from '../../hooks/message';
//import { useLocalization } from '../../hooks/localization';


export const CameraScreen = memo(function CameraScreen() {
    const getGatewayList = useSelector(state => state.control.gatewayList);
    const [selectedCamera, setSelectedCamera] = useState<CameraModel>(null);
    const [cameraMode, setCameraMode] = useState(null);
    //const {failure} = useMessage()
    //const {t} = useLocalization();
    const [rpc] = useRPC()
    //const history = useHistory()
    //const [isAllowedAccessCamera, setIsAllowedAccessCamera] = useState(false);

    const orientation = useOrientation();
    const cameraList = useSelector(state => state.control.cameraList);
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    const onCameraPress = useCallback((camera: CameraModel) => {
        if (selectedCamera) {
            setSelectedCamera(null);
            window.stop();
            window.close();
            console.log("24")
        } else {
            setSelectedCamera(camera);
        }
    }, [selectedCamera]);

    const onCameraModeChange = useCallback((mode: string) => {
        setCameraMode(mode);
        localStorage.setItem(`camera_mode_${selectedCamera?.id}`, mode);
    }, [selectedCamera?.id]);

    const cameraModeList = useMemo(() => {
        if (selectedCamera == null) {
            return [];
        }
        return [
            {text: 'CGI', value: 'video_cgi', key: 'video_cgi'},
            {text: 'RTSP', value: 'rtsp', key: 'rtsp'},
            {text: 'MJPEG', value: 'mjpeg', key: 'mjpeg'},
        ].filter(mode => selectedCamera[mode.value] != null);
    }, [selectedCamera]);

    useEffect(() => {
        dispatch(groupSettingAction({visible: false}));
    })

    useEffect(() => {
        /*if (isAllowedAccessCamera) {
            return
        }*/
        const data = localStorage.getItem(`camera_mode_${selectedCamera?.id}`);
        if (data != null) {
            setCameraMode(data);
        } else {
            if (cameraModeList.length > 0) {
                setCameraMode(cameraModeList[0].value);
            }
        }
    }, [cameraModeList, selectedCamera?.id]);


    const videoConstraints = {
        width: 180,
        height: 80,
        facingMode: "user"
    }

    const videoConstraintsHorizontal = {
        width: 180,
        height: 150,
        facingMode: "user"
    }


    const [isShowVideo, setIsShowVideo] = useState(true);
    const videoElement = useRef(null);
    const screenWidth = window.innerWidth;


    const closeCam = useCallback(() => {
        try {
          let stream = videoElement.current.stream;
          const tracks = stream.getTracks();
          tracks.forEach((track) => track.stop());
          window.stop();
        } catch (err) {
          rpc.frontendErrorLog("Camera device cannot be found!");
        }
    }, []);

    const initialCam = useCallback(() => {
      closeCam();
      setIsShowVideo(false);
    }, [closeCam]);

    const bigCam = useCallback(() => {
      closeCam();
      setIsShowVideo(true);
    }, [closeCam]);

    const isError = useCallback(() => {
        const tOut = setTimeout(function () {
           bigCam();
           rpc.frontendErrorLog("Connection failed!");
        }, 200);
        return () => clearTimeout(tOut);
    }, [bigCam, rpc]);


      useEffect(() => {
          rpc.getCameraList().then(camera => dispatch(setEntityListAction(camera, "camera")))
          /*rpc.checkUserAuthorization()
              .then(data => {
                  if (data) {
                    setIsAllowedAccessCamera(data)
                    history.push("/")
                    failure(t('unauthorized'))
                  }
              })*/
      }, [rpc, dispatch /*t, failure, rpc, history*/])

    return (
        <Container>
            <div className="page-wrapper">
                {
                    getGatewayList.map(control => {
                    const isNewTbell = control.settings.intercom.new_tbell_status;
                    const videoConstraintsBigScreen = {
                        width: isNewTbell ? 1280 : 1024,
                        height: isNewTbell ? 720 : 600,
                        facingMode: "user",
                        frameRate: isNewTbell ? 30 : undefined
                    };

                    return control.settings.intercom.has_usb_camera && (
                        <div className={'usb-camera-container' + (isNewTbell ? ' new-tbell' : '')} key={`control_${control.id}`}>
                            {renderIf(isShowVideo)(() => (
                                <div className={'usb-camera-box'} onClick={initialCam}>
                                    <div className="usb-camera-wrapper">
                                        <Webcam audio={false} ref={videoElement} videoConstraints={screenWidth <= 600 ? videoConstraintsHorizontal : videoConstraints} forceScreenshotSourceSize={true} screenshotQuality={1} onUserMediaError={isError} />
                                    </div>
                                    <div className="usb-camera-info">T-Bell</div>
                                </div>
                            ), () => (
                                <div className='usb-camera-big-screen-box' onClick={bigCam}>
                                    <div className="usb-camera-big-screen-wrapper">
                                        <Webcam audio={false} ref={videoElement} videoConstraints={videoConstraintsBigScreen} forceScreenshotSourceSize={true} screenshotQuality={1} onUserMediaError={isError}/>
                                    </div>
                                    <div className="usb-camera-big-screen-info">T-Bell</div>
                                </div>
                            ))}
                        </div>
                    );
                })
                }
                <div className="cameras-parent">
                    {
                        cameraList.map(camera => (
                            <div
                                key={`camera_${camera.id}`}
                                className={'image-parent ' + orientation + (selectedCamera === camera ? ' selected' : '')}
                                {...onClickHandler(() => onCameraPress(camera))}>
                                {
                                    renderIf(selectedCamera)(() =>
                                        <div className="camera-button-component" style={{zIndex: 3}}>
                                            {
                                                cameraModeList.map(({text, value, key}) =>
                                                    <div
                                                        className={`camera-button ${cameraMode === value ? 'active' : ''}`}
                                                        {...onClickHandler((e) => {
                                                            e.stopPropagation();
                                                            onCameraModeChange(value);
                                                        })}
                                                        key={key}>
                                                        {text}
                                                    </div>,
                                                )
                                            }
                                        </div>,
                                    )
                                }
                                <CameraRenderer
                                    className="preview"
                                    id={camera.id}
                                    mode={selectedCamera === camera ? cameraMode : 'snapshot'}
                                    quality={selectedCamera === camera ? 720 : 360}
                                />
                                <span>{camera.name}</span>
                            </div>
                        ))
                    }
                </div>
            </div>
        </Container>
    );
});
